import ATableAccess from "./aTableAccess";

class SystemConfigurationAccess extends ATableAccess {}

export default SystemConfigurationAccess;
